<template>
  <SectionView class="dynamic-tracking" :title="resolvedTitle">
    <div class="health-waterfall-chart">
      <div class="chart-header" v-if="showHeader">
        <div class="warning-section">
          <div class="warning-title">{{ $t('charts.elements.warningTip') }}</div>
          <div class="warning-count">
            <span class="count-number">{{ warningCount }}</span>
            <span class="count-total">/{{ totalItems }}</span>
          </div>
        </div>
        <div class="qualified-section">
          <div class="qualified-title">{{ $t('charts.elements.qualifiedItems') }}</div>
          <div class="qualified-count">
            <span class="count-number">{{ qualifiedCount }}</span>
            <span class="count-total">/{{ totalItems }}</span>
          </div>
        </div>
      </div>
      <div class="legend-container" v-if="showLegend">
        <div class="legend-item">
          <span class="legend-dot positive"></span>
          <span class="legend-text">{{ $t('charts.elements.excellentIndicator') }}</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot negative"></span>
          <span class="legend-text">{{ $t('charts.elements.needAttention') }}</span>
        </div>
        
      </div>
      <div ref="chart" class="chart-container"></div>
    </div>
  </SectionView>
</template>

<script>
/**
 * 动态数据跟踪组件
 * 用于展示健康指标的变化，从初值到终值的变化，支持正负值展示，不同颜色渐变
 */
import SectionView from "@/components/SectionView";

export default {
  name: "DynamicTrackingCard",
  components: {SectionView},

  props: {
    title: {
      type: String,
      default: ''
    },
    // 图表数据
    data: {
      type: Array,
      required: true
    },
    // 标签字段名
    labelKey: {
      type: String,
      default: 'name'
    },
    // 初始值字段名
    initialValueKey: {
      type: String,
      default: 'initialValue'
    },
    // 终值字段名
    finalValueKey: {
      type: String,
      default: 'finalValue'
    },
    // 是否显示头部统计
    showHeader: {
      type: Boolean,
      default: false
    },
    // 预警数量
    warningCount: {
      type: [Number, String],
      default: 0
    },
    // 合格数量
    qualifiedCount: {
      type: [Number, String],
      default: 0
    },
    // 总项目数
    totalItems: {
      type: [Number, String],
      default: 16
    },
    // 是否显示图例
    showLegend: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      chart: null,
      averageValues: [],
      allValues: [],
      finalValues: [],
      initialValues: [],
      echartsType:'custom',
      // echartsType:'custom',

    };
  },

  computed: {
    resolvedTitle() {
      return this.title || this.$t('charts.elements.dynamicDataTracking');
    }
  },

  mounted() {
    this.initChart();
    this.fixedRight();
    // 监听窗口大小变化，重新渲染图表
    window.addEventListener('resize', this.resizeChart);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },

  watch: {
    data: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },

  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart);
      this.updateChart();
      // this.handleUpdateRange()
    },

    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    fixedRight() {
      this.chart.on("dataZoom", () => {
        var currentZoom = this.chart.getOption().dataZoom[1];
        console.log('currentZoom',currentZoom)
        if (currentZoom.end !== 100) {
          this.chart.setOption({
            dataZoom: [
              {
                end: 100,
                start: currentZoom.start,
              },
            ],
          });
        }
      });
    },
    handleUpdateRange() {
      this.chart.on('dataZoom', (params) => {
        const {start, end} = params;

        const dataLen = this.finalValues.length;

        const startIndex = Math.floor((start / 100) * dataLen);
        const endIndex = Math.floor((end / 100) * dataLen);

        const v1 = this.initialValues.slice(startIndex, endIndex + 1);
        const v2 = this.finalValues.slice(startIndex, endIndex + 1);

        const maxY = Math.max(...v1, ...v2);
        const minY = Math.min(...v1, ...v2);
        const option = this.chart.getOption();

        // 更新 yAxis 范围
        console.log(this.chart)
        this.chart.setOption({
          ...option,
          yAxis: {
            ...option.yAxis[0],
            min: Math.floor(minY),
            max: Math.ceil(maxY)
          },
          dataZoom: option.dataZoom
        });
      });
    },

    updateChart() {
      if (!this.chart || !this.data || this.data.length === 0) return;
      // this.data = this.data.slice(0,100)
      const labels = this.data.map(item => item[this.labelKey] || '');
      const initialValues = this.data.map(item => parseFloat(item[this.initialValueKey]) || 0);
      const finalValues = this.data.map(item => parseFloat(item[this.finalValueKey]) || 0);
      const averageValues = this.data.map(item => parseFloat(item.av) || 0);

      // 获取所有初始值和终值
      const allValues = [...initialValues, ...finalValues];
      this.allValues = allValues;
      this.initialValues = initialValues;
      this.finalValues = finalValues;
      // const v1 = initialValues.slice(initialValues.length - 5, initialValues.length)
      // const v2 = finalValues.slice(finalValues.length - 5, finalValues.length)

      // const minValue = Math.min(...v1, ...v2);
      // const maxValue = Math.max(...v1, ...v2);
      const minValue = Math.min(...allValues);
      const maxValue = Math.max(...allValues);

// 计算数据范围
// 计算数据范围
//       const dataRange = maxValue - minValue
//       const padding = Math.max(Math.ceil(dataRange * 0.1), 1); // 确保padding是整数，至少为1
//
// 设置Y轴范围为整数
// const yAxisMin = Math.floor(minValue - padding);
// const yAxisMax = Math.ceil(maxValue + padding);



      // 计算均值用于决定颜色

      this.averageValues = averageValues;
      // const allValues = [...initialValues, ...finalValues];


      //
      // // 设置Y轴范围，比最大/最小值多1
      const yAxisMin = Math.floor(minValue -0.5);
      const yAxisMax = Math.ceil(maxValue + 0.5);


      // 使用普通柱状图代替自定义渲染
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#eee',
          borderWidth: 1,
          padding: 15,
          textStyle: {
            color: '#333'
          },
          formatter: (params) => {
            const index = params[0].dataIndex;
            const initialValue = initialValues[index];
            const finalValue = finalValues[index];
            // const changeRate = finalValue - initialValue;
            // const avgValue = averageValues[index];
            const meanValue = this.data[index].av || 0;
            // 使用传入的时间而不是当前时间
            const timeLabel = labels[index] || '';
            console.log(initialValues, '1111')
            let html = `<div style="font-size:16px;color:#2C324E;font-weight:500;">${timeLabel}</div>`;

            html += `<div style="margin-top:10px;">
                <span style="font-size:14px;color:#1E307D;">${this.$t('charts.elements.initialValue')}</span>
                <span style="float:right;font-size:14px;color:#1E307D;font-weight:bold;">${initialValue > 0 ? '+' + initialValue.toFixed(2) : initialValue.toFixed(2)}</span>
              </div>`;

            html += `<div style="margin-top:10px;">
                <span style="font-size:14px;color:#1E307D;">${this.$t('charts.elements.finalValue')}</span>
                <span style="float:right;font-size:14px;color:#1E307D;font-weight:bold;">${finalValue > 0 ? '+' + finalValue.toFixed(2) : finalValue.toFixed(2)}</span>
              </div>`;

            html += `<div style="margin-top:10px;">
                <span style="font-size:14px;color:#1E307D;">${this.$t('charts.elements.averageValue')}</span>
                <span style="float:right;font-size:14px;color:${meanValue >= 0 ? '#003CBF' : '#FF5C4D'};font-weight:bold;">${meanValue}</span>
              </div>`;

            return html;
          },
          extraCssText: 'box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); border-radius: 10px; padding: 20px;'
        },
        grid: {
          top: 40,
          bottom: 50,
          left: 10,
          right: 10,
          containLabel: true
        },
        // ... existing code ...
        dataZoom: [
          {
            type: 'inside',
            // 使用startValue和endValue直接指定显示的数据索引范围
            startValue: Math.max(0, this.data.length - 5),
            endValue: this.data.length - 1,
            zoomLock: true,
            moveOnMouseWheel: true,
            moveOnMouseMove: true,
            preventDefaultMouseMove: false,
            throttle: 0,
            rangeMode: ['value', 'value'],
            orient: 'horizontal'
          },
          {
            type: 'slider',
            show: true,
            xAxisIndex: 0,
            startValue: Math.max(0, this.data.length - 5),
            endValue: this.data.length - 1,
            bottom: 5, // 距离底部的距离
            height: 30, // 滚动轴高度
            handleSize: '80%',
            handleStyle: {
              color: '#4A90E2', // 蓝色手柄
              borderColor: '#4A90E2',
              borderWidth: 1,
              shadowBlur: 0 // 去掉阴影

            },
            fillerColor: '#E8F4FD', // 填充区域颜色
            backgroundColor: '#F5F5F5', // 背景颜色
            borderColor: 'transparent', // 去掉边框
            textStyle: {
              color: '#666',
              fontSize: 10
            },
            emphasis: {
              handleStyle: {
                color: '#357ABD'
              }
            },


          }
        ],
// ... existing code ...
        xAxis: {
          type: 'category',
          data: labels,
          axisLine: {
            lineStyle: {
              color: '#E8E8E8'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 'auto',
            fontSize: 10,
            color: '#959FB7', // 默认颜色
            formatter: function (value) {
              // 匹配日期格式，忽略时间部分（如果存在）
              const dateMatch = value.match(/(\d{4}[-/]\d{1,2}[-/]\d{1,2})/);
              if (dateMatch && dateMatch[1]) {
                const dateParts = dateMatch[1].split(/[-/]/);
                if (dateParts.length >= 3) {
                  return `${dateParts[1]}-${dateParts[2]}`; // 只显示月-日
                }
              }
              // 非日期格式的处理逻辑
              if (value.length > 2) {
                return value.substring(0, 3) + '..';
              }
              return value;
            }
          }
        },
        yAxis: {
          type: 'value',
          min: yAxisMin,
          max: yAxisMax,
          axisLine: {
            show: false,
            lineStyle: {
              color: '#CCCCCC'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#CCCCCC'
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            type: this.echartsType,
            name: '好棒棒',
            renderItem: function (params, api) {
              const xValue = api.value(0);
              const initialValue = api.value(1);
              const finalValue = api.value(2);
              const averageValue = api.value(3);

              // 计算坐标点
              const start = api.coord([xValue, initialValue]);
              const end = api.coord([xValue, finalValue]);

              // 动态计算柱子宽度
              const chartWidth = api.getWidth();
              const dataCount = params.dataInsideLength;
              const maxBarWidth = Math.min(chartWidth / dataCount * 0.2, 20);
              const barWidth = Math.max(maxBarWidth, 0.5);

              const isPositive = averageValue > 0;


              const color = isPositive ? {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: finalValue > initialValue ? [
                  {offset: 0, color: '#003CBF'},
                  {offset: 1, color: '#FCFDFF'}
                ] : [
                  {offset: 0, color: '#FCFDFF'},
                  {offset: 1, color: '#003CBF'}
                ]
              } : {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: finalValue < initialValue ? [
                  {offset: 0, color: '#FFF3F3'},
                  {offset: 1, color: '#FF5C4D'}
                ] : [
                  {offset: 0, color: '#FF5C4D'},
                  {offset: 1, color: '#FFF3F3'}
                ]
              };

              // 返回矩形形状
              return {
                type: 'rect',
                shape: {
                  x: start[0] - barWidth / 2,
                  y: Math.min(start[1], end[1]),
                  width: barWidth,
                  height: Math.abs(end[1] - start[1]),
                  r: [12, 12, 12, 12] // 圆角半径
                },
                style: {
                  fill: color
                }
              };
            },
            // 数据格式：[x值, 初始值, 终值]
            data: this.data.map((item, index) => [
              index, // x轴位置
              item[this.initialValueKey], // 初始值
              item[this.finalValueKey], // 终值
              parseFloat(item.av) || 0 // 均值
            ])
          }
        ]
      };

      this.chart.setOption(option);
      // this.chart.off('click');
      //     this.chart.on('click', (params) => {
      //       // 获取当前点击的索引
      //       const clickedIndex = params.dataIndex;

      //       // 更新X轴标签颜色
      //       this.chart.setOption({
      //         dataZoom: [
      //   {
      //     type: 'inside',
      //     startValue: 0,
      //     endValue: Math.min(5, this.data.length - 1),
      //     zoomLock: true,
      //     moveOnMouseWheel: true,
      //     moveOnMouseMove: true,
      //     preventDefaultMouseMove: false,
      //     throttle: 0,
      //     rangeMode: ['value', 'value'],
      //     orient: 'horizontal'
      //   }
      // ],
      //         xAxis: {
      //           axisLabel: {
      //             color: (value, index) => {
      //               // 只有选中的标签显示特定颜色
      //               if (index === clickedIndex) {
      //                 const avgValue = averageValues[index];
      //                 return avgValue < 0 ? '#FF5C4D' : '#003CBF';
      //               }
      //               return '#959FB7'; // 默认颜色
      //             }
      //           }
      //         }
      //       });
      //     });

      if (this.data.length > 0) {
        this.chart.dispatchAction({
          type: 'highlight',
          seriesIndex: 1, // 注意这里改为1，因为我们现在有两个系列
          dataIndex: 0
        });

        // 显示第一个柱状图的提示框
        this.chart.dispatchAction({
          type: 'showTip',
          seriesIndex: 1,
          dataIndex: 0
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dynamic-tracking {
  margin-top: 50px;

  .health-waterfall-chart {
    width: 100%;
    background-color: #F5F5F5;

    .chart-header {
      display: flex;
      border-bottom: 1px solid #f0f0f0;

      .warning-section, .qualified-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .warning-title, .qualified-title {
          font-size: 32px;
          margin-bottom: 5px;
        }

        .warning-count, .qualified-count {
          .count-number {
            font-size: 32px;
            font-weight: bold;
          }

          .count-total {
            font-size: 16px;
            color: #999;
          }
        }
      }

      .warning-section {
        .warning-title {
          color: #FF5C4D;
        }

        .count-number {
          color: #FF5C4D;
        }
      }

      .qualified-section {
        .qualified-title {
          color: #003CBF;
        }

        .count-number {
          color: #003CBF;
        }
      }
    }

    .chart-container {
      height: 640px;
      width: 100%;
    }

    .legend-container {
      display: flex;
      justify-content: flex-end;
      margin: 10px 0;

      .legend-item {
        display: flex;
        align-items: center;
        margin: 0 15px;

        .legend-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 5px;

          &.negative {
            background-color: #FF5C4D;
          }

          &.positive {
            background-color: #003CBF;
          }
        }

        .legend-text {
          color: #00133D;
          font-weight: 400;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
